var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDockPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4577 9.16699V8.33366C16.4577 5.19116 16.4577 3.61949 15.4818 2.64366C14.506 1.66783 12.9327 1.66699 9.79102 1.66699H8.95768C5.81602 1.66699 4.24352 1.66699 3.26768 2.64366C2.29185 3.62033 2.29102 5.19116 2.29102 8.33366V11.667C2.29102 14.8095 2.29102 16.3812 3.26768 17.357C4.24435 18.3328 5.81518 18.3337 8.95768 18.3337",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04102 5.83398H12.7077M6.04102 10.0007H12.7077",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.041 17.3565V18.334H12.0193C12.3602 18.334 12.531 18.334 12.6843 18.2707C12.8377 18.2074 12.9585 18.0865 13.1993 17.8457L17.2193 13.8249C17.4468 13.5974 17.561 13.4832 17.621 13.3616C17.7368 13.1282 17.7368 12.8532 17.621 12.6199C17.5602 12.4974 17.446 12.384 17.2193 12.1565C16.991 11.929 16.8777 11.8149 16.7552 11.754C16.64 11.6968 16.513 11.667 16.3843 11.667C16.2557 11.667 16.1287 11.6968 16.0135 11.754C15.891 11.8149 15.7768 11.929 15.5502 12.1565L11.5302 16.1765C11.2885 16.4174 11.1685 16.5382 11.1052 16.6915C11.0418 16.8449 11.041 17.0149 11.041 17.3565Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockPen);
export default __webpack_public_path__ + "static/media/dock_pen.98140b295b418a40ca4a5fa981eadb25.svg";
export { ForwardRef as ReactComponent };